import React, { useState } from 'react';
import classes from "./style.module.scss";
import pencilIcon from "assets/images/icons/pencil.svg";

export default ({ 
    label = "",
    index = -1,
    className,
    disabled,
    large,
    onSave 
}) => {

    const classNames = [
        classes.editableLabelField,
        className && className,
        disabled && classes.disabled,
        large && classes.large,
    ].filter((c) => c);

    const [isEditing, setIsEditing] = useState(false);
    const [currentLabel, setCurrentLabel] = useState(label);

    const toggleEditMode = () => {
        setIsEditing(!isEditing);
    };

    const handleLabelChange = (e) => {
        setCurrentLabel(e.target.value);
    };

    const saveLabel = () => {
        setIsEditing(false);
        if (onSave) {
            onSave(`${currentLabel} (${index + 1})`); // add index to label after editing
        }
    };

    return (
        <div className={classNames.join(' ')}>
            <div className={classes.labelContainer}>
                {isEditing ? (
                    <input
                        type="text"
                        value={currentLabel}
                        onChange={handleLabelChange}
                        onBlur={saveLabel}
                        className={classes.labelInput}
                    />
                ) : (
                    <span className={classes.labelText}>{label}</span> // display original label
                )}
                <img
                    src={pencilIcon}
                    alt="Edit"
                    className={classes.pencilIcon}
                    onClick={toggleEditMode} // toggle edit mode on pencil click
                />
            </div>
        </div>
    );
};